
export const EN_msgs = {
}